export const CSV_HEADERS = [
    { label: 'First Name', key: 'fName' },
    { label: 'Middle Name', key: 'mName' },
    { label: 'Last Name', key: 'lName' },
    { label: 'DLN', key: 'permitNo' },
    { label: 'Date Of Birth (MM/DD/YYYY)', key: 'dob' },
    { label: 'Student Email', key: 'emailAddress' },
    { label: 'Total Program Cost', key: 'totalProgram' },
    { label: 'Payment Type', key: 'paymentType' },
    { label: 'Initial Payment', key: 'initalPayment' }
];

export const TIME_OPTIONS = [
    { "label": "5 Minutes", "value": 5 },
    { "label": "10 Minutes", "value": 10 },
    { "label": "15 Minutes", "value": 15 },
    { "label": "30 Minutes", "value": 30 },
    { "label": "45 Minutes", "value": 45 },
    { "label": "60 Minutes", "value": 60 }
];

export const WEEKDAY_BUTTONS = [
    { id: "sat", label: "Saturday" },
    { id: "sun", label: "Sunday" },
    { id: "mon", label: "Monday" },
    { id: "tue", label: "Tuesday" },
    { id: "wed", label: "Wednesday" },
    { id: "thu", label: "Thursday" },
    { id: "fri", label: "Friday" }
];
